import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Edit, Eye } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import api from '../api';
import { PageHeader } from '../components/common';
import { ShadcnDataTable } from '../components/ShadcnDataTable';
import { Button } from '../components/ui/button';

export default function BuyerList() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadBuyers();
  }, []);

  const loadBuyers = async () => {
    try {
      const response = await api.get('/compradores');
      setData(response.data);
    } catch (error) {
      console.error('Error loading buyers:', error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { 
      field: 'nomeFantasia', 
      headerName: t('buyerList.columns.name'), 
      flex: 1,
      renderCell: (row) => row.nomeFantasia || '-'
    },
    { 
      field: 'email', 
      headerName: t('buyerList.columns.email'), 
      flex: 1,
      renderCell: (row) => row.contatoPrincipal?.email || '-'
    },
    { 
      field: 'telefone', 
      headerName: t('buyerList.columns.phone'), 
      flex: 1,
      renderCell: (row) => row.contatoPrincipal?.telefone || row.contatoPrincipal?.celular || '-'
    },
    { 
      field: 'cidade', 
      headerName: t('buyerList.columns.city'), 
      flex: 1,
      renderCell: (row) => row.endereco?.cidade || '-'
    },
    { 
      field: 'estado', 
      headerName: t('buyerList.columns.state'), 
      width: 100,
      renderCell: (row) => row.endereco?.estado || '-'
    },
    {
      field: 'status',
      headerName: t('buyerList.columns.status'),
      width: 120,
      renderCell: (row) => (
        <span className="px-2 py-1 text-xs rounded-[4px] bg-green-100 text-green-800">
          {t('buyerList.status.active')}
        </span>
      )
    }
  ];

  const actions = [
    {
      icon: <Eye className="h-4 w-4" />,
      label: t('buyerList.actions.view'),
      onClick: (row) => navigate(`/admin/compradores/${row._id}`),
      className: 'text-gray-600 hover:text-primary'
    },
    {
      icon: <Edit className="h-4 w-4" />,
      label: t('buyerList.actions.edit'),
      onClick: (row) => navigate(`/admin/compradores/${row._id}/edit`),
      className: 'text-gray-600 hover:text-primary'
    }
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title={t('buyers.title')}
        description={t('buyers.description')}
      >
        <motion.div
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <Button
            variant="default"
            onClick={() => navigate('/admin/compradores/create')}
            className="flex items-center gap-1"
          >
            <Plus className="h-4 w-4" />
            {t('buyers.newBuyer')}
          </Button>
        </motion.div>
      </PageHeader>

      <div className="space-y-4">
        <ShadcnDataTable
          columns={columns}
          data={data}
          loading={loading}
          actions={actions}
          onRowClick={(row) => navigate(`/admin/compradores/${row._id}`)}
        />
      </div>
    </div>
  );
}